// src/pages/UnderConstruction.tsx
import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { FaTools, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import logo from "../assets/images/LogoMercadito.png";

const UnderConstruction: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* ===== Animación del degradado ===== */}
      <style>
        {`
          @keyframes gradientMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>

      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          minHeight: "100vh",
          background: "linear-gradient(180deg, #ffffff 0%, #f7f7f7 100%)",
          padding: "24px",
        }}
      >
        <Container style={{ maxWidth: 760 }}>
          <Card
            className="shadow-lg border-0"
            style={{ borderRadius: 18, overflow: "hidden" }}
          >
            {/* ===== Header / Logo ===== */}
            <div
              className="text-center position-relative"
              style={{
                padding: "40px 24px 24px",
                background:
                  "linear-gradient(135deg, #956047, #7d4f3b, #956047)",
                backgroundSize: "200% 200%",
                animation: "gradientMove 8s ease infinite",
              }}
            >
              {/* Overlay sutil */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "radial-gradient(circle at top, rgba(255,255,255,0.18), transparent 60%)",
                }}
              />

              <div className="position-relative">
                <img
                  src={logo}
                  alt="Webb Gym"
                  style={{
                    height: 115,
                    width: "auto",
                    objectFit: "contain",
                    filter:
                      "drop-shadow(0 12px 20px rgba(0,0,0,0.4))",
                  }}
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display =
                      "none";
                  }}
                />

                <div
                  className="mx-auto mt-3 d-inline-flex align-items-center gap-2"
                  style={{
                    padding: "8px 16px",
                    borderRadius: 999,
                    background: "rgba(255,255,255,0.18)",
                    color: "#ffffff",
                    fontWeight: 600,
                    fontSize: 14,
                    backdropFilter: "blur(4px)",
                  }}
                >
                  <FaTools />
                  <span>Webb Gym</span>
                </div>
              </div>
            </div>

            {/* ===== Body ===== */}
            <Card.Body style={{ padding: "28px 26px" }}>
              <h2
                className="text-center mb-2"
                style={{
                  color: "#3C3C3C",
                  fontWeight: 800,
                }}
              >
                Sección en desarrollo
              </h2>

              <p
                className="text-center mb-4"
                style={{
                  color: "#3C3C3C",
                  opacity: 0.85,
                  fontSize: 16,
                  lineHeight: 1.6,
                }}
              >
                Estamos trabajando en mejoras y pronto estará disponible.
              </p>

              <div className="d-flex justify-content-center">
                <Button
                  onClick={() => navigate("/")}
                  style={{
                    borderRadius: 12,
                    padding: "10px 20px",
                    backgroundColor: "#3C3C3C",
                    borderColor: "#3C3C3C",
                    color: "#ffffff",
                  }}
                >
                  <FaHome className="me-2" />
                  Volver al inicio
                </Button>
              </div>

              <hr className="my-4" />

              <p
                className="text-center mb-0"
                style={{
                  color: "#956047",
                  fontWeight: 700,
                  fontSize: 15,
                }}
              >
                Gracias por ser parte de nuestros clientes
              </p>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default UnderConstruction;
